import React, { useEffect } from "react";

import { Box, Typography, TextField } from "@mui/material";
import './DetailForm.css';
export const OrderForm = (props) => {
  const { customer_email } = props;
  useEffect(() => {
    console.log(props);
  }, []);
  return (
    <Box className="Box2">
      <TextField className="TextField2" id="outlined-basic" value={customer_email} label="Customer Order" variant="outlined" InputLabelProps={{ shrink: customer_email ? true : false }} />

    </Box>
  );
};